import { render, staticRenderFns } from "./webhook.vue?vue&type=template&id=0f7b5f92&scoped=true&"
import script from "./webhook.vue?vue&type=script&lang=js&"
export * from "./webhook.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f7b5f92",
  null
  
)

export default component.exports